import React, { useEffect, useState } from 'react';

const CountdownTimer: React.FC<{ seconds: number; onComplete: () => void }> = ({
  seconds,
  onComplete
}: {
  seconds: number;
  onComplete: () => void;
}) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onComplete]);

  const minutes = Math.floor(timeLeft / 60);
  const remainingSeconds = timeLeft % 60;
  const progress = ((seconds - timeLeft) / seconds) * 100;

  return (
    <div className='flex flex-col items-center space-y-4'>
      <div className='relative h-32 w-32'>
        <svg className='h-32 w-32 -rotate-90 transform' viewBox='0 0 100 100'>
          <circle
            cx='50'
            cy='50'
            r='45'
            stroke='currentColor'
            strokeWidth='4'
            fill='none'
            className='text-gray-200'
          />
          <circle
            cx='50'
            cy='50'
            r='45'
            stroke='currentColor'
            strokeWidth='4'
            fill='none'
            strokeDasharray={`${2 * Math.PI * 45}`}
            strokeDashoffset={`${2 * Math.PI * 45 * (1 - progress / 100)}`}
            className='text-red-500'
            style={{ transition: 'stroke-dashoffset 1s linear' }}
          />
        </svg>
        <div className='absolute inset-0 flex items-center justify-center'>
          <span className='text-2xl font-bold text-white'>
            {minutes}:{remainingSeconds.toString().padStart(2, '0')}
          </span>
        </div>
      </div>
      <div className='flex items-center space-x-2 text-red-600'>
        <div className='mt-4 flex justify-center'>
          <div className='flex h-8 items-end gap-1'>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '20%' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '40%', animationDelay: '0.1s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '60%', animationDelay: '0.2s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '80%', animationDelay: '0.3s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '100%', animationDelay: '0.4s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '80%', animationDelay: '0.5s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '60%', animationDelay: '0.6s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '40%', animationDelay: '0.7s' }}
            ></div>
            <div
              className='w-2 animate-pulse rounded bg-red-500'
              style={{ height: '20%', animationDelay: '0.8s' }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
